<app-header></app-header>
<div class="row mt-4 ml-3 mr-1">
  <h3>{{displayName}}</h3>
</div>

<div class="row mt-1 ml-1 mr-1">
  
  <div class="col">
    <ngx-spinner></ngx-spinner>
    <div class="cards">
      <div *ngFor="let psc of productSubCategories" class="card">
        <img src="{{baseUrl + psc.productSubCategoryImageName}}" class="card-img-top" alt="{{psc.productSubCategory1}}"
          title="{{psc.productSubCategory1}}">
        <div class="card-body">
          <h5 class="card-title">{{psc.productSubCategory1}}</h5>
          <p class="card-text">{{psc.productSubCategoryDescription}}</p>
          <!-- <a href="printgroups/{{psc.productSubCategoryId}}?name={{encodeContent(psc.productSubCategory1)}}"
            class="stretched-link" title="{{psc.productSubCategory1}}"></a> -->

          <a class="stretched-link" [attr.href]="(productCategoryid == 2 && psc.productSubCategoryId !=5)
                        ? ('nomenclature/'+psc.productSubCategoryId+'/FOLDINGCARTON/false/false?name='+encodeContent(psc.productSubCategory1)) 
                        : ('printgroups/'+psc.productSubCategoryId+'?name='+encodeContent(psc.productSubCategory1))"
            title="{{psc.productSubCategory1}}"></a>
        </div>
      </div>
    </div>
  </div>
</div>
